import { render, staticRenderFns } from "./TitleAdded.vue?vue&type=template&id=408eadb4&scoped=true"
import script from "./TitleAdded.vue?vue&type=script&lang=js"
export * from "./TitleAdded.vue?vue&type=script&lang=js"
import style0 from "./TitleAdded.vue?vue&type=style&index=0&id=408eadb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "408eadb4",
  null
  
)

export default component.exports